import checkout from './Form'

const {
  formField: {
    // datas
    name,
    CNPJ,
    employer_code,
  }
} = checkout

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // datas
  [name.name]: "",
  [CNPJ.name]: "",
  [employer_code.name]: "",
}